import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Tooltip } from '..';

import {
  IconElement,
  IconPasswordWrapper,
  IconWrapper,
  InputControl,
  InputWrapper,
  Placeholder
} from './style';

const Input = ({ icon, isShowPassword, value, ...props }) => {
  const [showPassword, setShowPAssword] = useState(false);

  return (
    <InputWrapper
      value={value}
      variant={props.variant}
      status={props.status}
      phoneSection={props.phoneSection}
      customWidth={props.customWidth}
    >
      {props.variant === 'editaccountdata' && (
        <Placeholder hasValue={value?.length > 0} status={props.status}>
          {props.placeholder}
        </Placeholder>
      )}
      <InputControl
        {...props}
        value={value}
        type={
          isShowPassword ? (showPassword ? 'text' : 'password') : props.type
        }
      />

      {icon && <IconWrapper iconInput>{icon}</IconWrapper>}
      {isShowPassword && (
        <IconPasswordWrapper onClick={() => setShowPAssword(!showPassword)}>
          {showPassword ? (
            <IconElement variant={props.variant} className="icon-eye-closed" />
          ) : (
            <IconElement variant={props.variant} className="icon-eye-show" />
          )}
        </IconPasswordWrapper>
      )}
      {props.tooltipText && (
        <div style={props.innerTooltip ? { position: 'relative' } : null}>
          <IconElement
            data-tip={props.tooltipText}
            variant={props.variant}
            className="icon-info"
            innerTooltip={props.innerTooltip}
          />
          <Tooltip />
        </div>
      )}
    </InputWrapper>
  );
};

Input.defaultProps = {
  innerTooltip: false
};

Input.propTypes = {
  icon: PropTypes.node,
  variant: PropTypes.oneOf([
    'login',
    'rfid',
    'otp',
    'changeaccountpassword',
    'insertotp',
    'rfid',
    'firmware',
    'form',
    'editaccountdata'
  ]),
  isShowPassword: PropTypes.bool,
  tooltipText: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.string,
  innerTooltip: PropTypes.bool,
  value: PropTypes.string
};

export default Input;
